export const prepPhone = (phone = "") => {
    let RU = phone.match(/(\d{1})(\d{3})(\d{3})(\w{2})(\w{2})/)
    return `${RU[1]} (${RU[2]}) ${RU[3]}-${RU[4]}-${RU[5]}`
  }

export const nowStamp = () => Math.floor(Date.now()/1000)
export const storeState = (key, val) => {
    let data = JSON.parse(localStorage.getItem("_wh"))
    if (data) {
        data[key] = val
        localStorage.setItem("_wh", JSON.stringify(data))
        return
    }
    data = {}
    data[key] = val
    localStorage.setItem("_wh", JSON.stringify(data))
}

export const getState = (key) => {
    const data = JSON.parse(localStorage.getItem("_wh"))
    if (data) {
        return data[key]
    }
    return null
}

export const clearState = () => {localStorage.removeItem("_wh")}

export const checkNumberPhone = (event, setValue, setError) => {
    if (event.target.value[0] === '7' || event.target.value[0] === '8') {
        setValue(
            event.target.value
                .replace(/\D/g, '')
                .substring(0, 11)
                .split('')
                .reduce((acc, cur, idx) => {
                    let spacer = ""

                    if (idx === 0) {
                        spacer = "("
                    } else if (idx === 3) {
                        spacer = ") "
                    } else if (idx === 6 || idx === 8) {
                        spacer = "-"
                    }

                    return acc + cur + spacer;
                }, '')
                .replace(/([-]*)$/g, '')
        )
    } else if (event.target.value[0] === '9') {
        setValue(
            event.target.value
                .replace(/\D/g, '')
                .substring(0, 11)
                .split('')
                .reduce((acc, cur, idx) => {
                    let spacer = ""

                    if (idx === 0) {
                        spacer = "("
                    } else if (idx === 3) {
                        spacer = ") "
                    } else if (idx === 6 || idx === 8) {
                        spacer = "-"
                    }

                    if (cur === "9" && idx === 0 && navigator.language === 'ru-RU') {
                        return '8' + acc + cur
                    }
                    return acc + cur + spacer
                }, '')
                .replace(/([-]*)$/g, '')
        )
    } else {
        setValue(
            event.target.value
                .replace(/\D/g, '')
                .substring(0, 14)
                .replace(/([-]*)$/g, '')
        )
    }
    setError("")
}

export const getErrorByStatus = (status, setError, translateError) => {
    switch (status) {
        case 400:
            setError("Неверные параметры запроса")
            break
        case 410:
            setError("Проверьте наличие и возможность сохранения Cookies в вашем браузере")
            break
        case 403:
            setError(translateError('auth_block'))
            break
        case 404:
            setError(translateError('err_notfound'))  
            break
        case 405:
            setError("Ресурс был удален с системы. Обратитесь к провайдеру услуги")
            break
        case 409:
            setError(translateError('phone_filter_mess'))
            break
        case 408:
            setError("Нет доступного шлюза. Повторите запрос позднее")
            break
        case 422:
            setError("Недопустимая комбинация проверяемых данных")
            break    
        case 423:
            setError(translateError('fail2block_mess'))
            break
        case 461:
            setError("Срок действия попытки авторизации истек. Попробуйте снова")
            break
        case 500:
            setError(translateError('err_int'))
            break
        case 502:
            setError(translateError('err_sms'))
            break
        default:
            setError(translateError('err_sgw'))
            break
    }
}